import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Pagination } from '../../atoms';
import { MetaContainer } from '../../organisms/Table';
import { TABLE_PAGE_SIZE_OPTIONS } from '../../constants';
import { RootState } from '../../redux/root';
import { setPageIndex, setPageSize } from '../../redux/slices/paginationSlice';

const PaginationMobile:FC<{showEverywhere?: boolean}> = ({ showEverywhere }) => {
    const {
        pageSize,
        pageCount,
        pageIndex,
    } = useSelector((state: RootState) => state.pagination);
    const dispatch = useDispatch();
    const gotoPage = (arg:number) => {
        dispatch(setPageIndex(arg));
    };

    return (
      <MetaContainer>
        <MetaContainerMobile showEverywhere={showEverywhere}>
          <div>
            {pageCount > 1 && (
              <Pagination
                pageSize={pageSize}
                current={pageIndex + 1}
                total={pageCount * pageSize}
                onChange={pageNumber => gotoPage(pageNumber - 1)}
              />
            )}
          </div>
          <select
            value={pageSize}
            onChange={e => dispatch(setPageSize(Number(e.target.value)))}
          >
            {TABLE_PAGE_SIZE_OPTIONS.map(ps => (
              <option key={ps.value} value={ps.value}>
                {ps.label}
              </option>
              ))}
          </select>
        </MetaContainerMobile>
      </MetaContainer>
    );
};

const MetaContainerMobile = styled.div<{showEverywhere?: boolean}>`
    display: ${({ showEverywhere }) => (showEverywhere ? 'flex' : 'none')};
    width: ${({ showEverywhere }) => (showEverywhere ? '100%' : 'auto')};
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;

    > select {
        height: 36px;
        min-width: 72px;
        padding: 0 32px 0 12px;
        border: 1px solid var(--border);
        border-radius: 8px;
        background-color: var(--neutral-0);
        background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px center;
        color: var(--mainText);
        font-family: inherit;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        outline: none;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
        box-sizing: border-box;

        &:hover {
            border-color: var(--neutral-400);
        }

        &:focus,
        &:focus-visible {
            border-color: var(--primary-600);
            box-shadow: var(--shadow-focus);
        }

        &::-ms-expand {
            display: none;
        }
    }

    @media only screen and (max-width: 1366px) {
        display: flex;
    }

    @media only screen and (max-width: 840px) {
        width: 100%;
    }
`;
export default PaginationMobile;
